import type { SourceFreshness } from '../services/freshnessApi';

/** «2026-10-20» → «10-20», a past year keeps its year: «2026-02-07» in 2027 → «2026-02-07». */
export function asOfLabel(iso: string | null | undefined, now = new Date()): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const pad = (n: number) => String(n).padStart(2, '0');
  const md = `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return d.getFullYear() === now.getFullYear() ? md : `${d.getFullYear()}-${md}`;
}

/** The sources the main pages are built on — a problem there gets a banner. */
export const CORE_SOURCES = ['tender', 'bid'];

/** One sentence on a source that is behind, or null when it is current. */
export function problemText(s: SourceFreshness): string | null {
  if (s.status === 'ok') return null;
  const since = `${asOfLabel(s.as_of)}-ны байдлаар`;
  return s.reason ? `${s.name}: ${since} — ${s.reason.toLowerCase()}` : `${s.name}: ${since}, шинэчлэгдээгүй байна`;
}
